type SVGProps = {
  color?: string;
  width?: string | number;
  height?: string | number;
  className?: string;
};

const Info = ({ color, width, height, className }: SVGProps) => (
  <svg
    focusable={false}
    xmlns='https://www.w3.org/2000/svg'
    width={height}
    height={width}
    className={className}
    viewBox='0 0 24 24'
  >
    <g fill='none' fillRule='evenodd' stroke={color}>
      <path
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M12 16.5V9.3h-1.125M12 6.5v.8m-1.5 9.2h3'
      />
      <circle cx={12} cy={12} r={10} />
    </g>
  </svg>
);

export default Info;
